<template>
    <survey-loader full />
</template>
<script src="./Redirect.ts"></script>
